module.exports = __webpack_public_path__ + "img/game_phone_en.ecd6cfc7.png";